import React, { ReactElement } from 'react';
import { FormControlProps } from 'react-bootstrap';
import { UseFormInput } from 'hooks/useFormInput';
import BzFormControl, { BzFormControlProps } from 'components/forms/BzFormControl';
import _ from 'lodash';
import clsx from 'clsx';
import styles from './BzFormControlWithHook.module.css';

interface BzFormControlWithHookProps {
  useFormInputHook: UseFormInput;
  hideErrors?: boolean;
  pattern?: string;

  /** Optional icon component which will placed on the right side of the input. */
  icon?: ReactElement;
}

type BzmHookProps = BzFormControlWithHookProps & BzFormControlProps & FormControlProps;

/**
 * A wrapper for BzFormControl input to simplify its usage along with a useFormInput hook. Can be used
 * only within a functional component.
 */
const BzFormControlWithHook = React.forwardRef((props: BzmHookProps, ref: any) => {
  const formControl = (
    <BzFormControl
      autoComplete={props.autoComplete}
      disabled={props.disabled}
      required={props.required}
      type={props.type}
      placeholder={props.placeholder}
      invalidMessage={props.useFormInputHook.invalidMessage}
      invalid={!props.useFormInputHook.valid}
      onChange={props.useFormInputHook.onChange}
      value={_.isNil(props.useFormInputHook.value) ? '' : (props.useFormInputHook.value as string)}
      className={props.className}
      name={props.name}
      dirty={props.useFormInputHook.dirty}
      id={props.id}
      validating={props.useFormInputHook.validating}
      hideErrors={props.hideErrors}
      pattern={props.pattern}
      readOnly={props.readOnly}
      title={props.title}
      tooltipEnabled={props.tooltipEnabled}
      tooltipPosition={props.tooltipPosition}
      ref={ref}
    />
  );

  if (!_.isNil(props.icon)) {
    return (
      <div className={'position-relative'}>
        <span className={clsx('position-absolute', styles.formIcon)}>{props.icon}</span>
        {formControl}
      </div>
    );
  }
  return formControl;
});

BzFormControlWithHook.displayName = 'BzmControlWithHook';

export default BzFormControlWithHook;
